import { useDisclosure } from "@heroui/react";
import { FileUploadModal } from "./fileUploadModal";

export function useFileUploadModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openFileUploadModal = ({
    onFileUploaded,
    accept = "image/*",
    multiple = false,
    listUploadedFiles = false,
    searchParams = {},
  }: {
    onFileUploaded: (urls: string[]) => void;
    accept?: string;
    multiple?: boolean;
    listUploadedFiles?: boolean;
    searchParams?: {
      [key: string]: string | number | boolean;
    };
  }) => {
    return (
      <FileUploadModal
        isOpen={isOpen}
        onClose={onClose}
        onFileUploaded={onFileUploaded}
        accept={accept}
        multiple={multiple}
        listUploadedFiles={listUploadedFiles}
        searchParams={searchParams}
      />
    );
  };

  return {
    FileUploadModal: openFileUploadModal,
    onOpen,
    onClose,
  };
}
